module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/support-71eca2c434658a8f19c6ece9742a410c.svg";